export const ruCommon = {
  // Header
  home: "Главная",
  services: "Услуги",
  reservation: "Бронирование",
  about: "О нас",
  blog: "Блог",
  contact: "Контакты",
  myReservation: "Мои бронирования",
  
  // Hero
  heroTitle: "Сделайте свой отдых в Турции незабываемым",
  heroSubtitle: "Трансфер, частные туры, морские прогулки, аренда автомобилей и многое другое…",
  
  // Services
  transferService: "Трансфер",
  privateTours: "Частные туры",
  groupTours: "Групповые туры",
  boatTours: "Аренда яхт",
  carRental: "Аренда автомобилей",
  villaRental: "Аренда вилл",
  
  // Transfer Page
  transferServices: "Услуги трансфера",
  transferHeroDesc: "Комфортное путешествие с трансфером из аэропорта, междугородним трансфером и VIP-встречей",
  transferOptions: "Наши варианты трансфера",
  transferOptionsDesc: "Выберите услугу трансфера, которая соответствует вашим потребностям",
  airportHotel: "Аэропорт - Отель",
  airportHotelDesc: "Комфортный трансфер из аэропорта в ваш отель",
  hotelAirport: "Отель - Аэропорт",
  hotelAirportDesc: "Безопасный трансфер из отеля в аэропорт",
  intercityTransfer: "Междугородний трансфер",
  intercityTransferDesc: "Трансфер в любую точку Турции",
  vipWelcome: "VIP встреча",
  vipWelcomeDesc: "Специальная встреча и VIP трансфер",
  chauffeurService: "Почасовая аренда с водителем",
  chauffeurServiceDesc: "Профессиональная почасовая аренда автомобиля с водителем, идеально для городских экскурсий и специальных мероприятий",
  ourFleet: "Наш автопарк",
  ourFleetDesc: "Роскошные и комфортабельные автомобили для ваших нужд",
  economySedanName: "Эконом седан",
  comfortSedanName: "Комфорт седан",
  mercedesVitoName: "Mercedes Vito VIP",
  mercedesSprinterName: "Mercedes Sprinter",
  minibusName: "Микроавтобус 15+1",
  busName: "Автобус 46 мест",
  passengers: "Пассажиры",
  luggage: "Багаж",
  airConditioning: "Кондиционер",
  comfortableSeats: "Удобные сиденья",
  experiencedDriver: "Опытный водитель",
  premiumAC: "Премиум кондиционер",
  leatherSeats: "Кожаные сиденья",
  vipDriver: "VIP водитель",
  waterService: "Вода",
  vipInterior: "VIP интерьер",
  largeLuggage: "Большой багаж",
  premiumComfort: "Премиум комфорт",
  refreshmentService: "Напитки",
  spaciousInterior: "Просторный салон",
  comfortableJourney: "Комфортное путешествие",
  professionalDriver: "Профессиональный водитель",
  wideSeats: "Широкие сиденья",
  luggageCompartment: "Багажное отделение",
  premiumSeats: "Премиум сиденья",
  wcAvailable: "Туалет",
  tvAvailable: "ТВ",
  largeLuggageSpace: "Большое багажное пространство",
  
  // Reservation Form
  transferReservation: "Бронирование трансфера",
  transferType: "Тип трансфера",
  selectTransferType: "Выберите тип трансфера",
  from: "Откуда",
  to: "Куда",
  departurePoint: "Точка отправления",
  arrivalPoint: "Точка прибытия",
  date: "Дата",
  time: "Время",
  flightCode: "Код рейса (необязательно)",
  flightCodePlaceholder: "Например: TK1234",
  passengerInfo: "Информация о пассажирах",
  addPassenger: "Добавить пассажира",
  firstName: "Имя",
  lastName: "Фамилия",
  phoneNumber: "Номер телефона",
  phonePlaceholder: "+90 555 123 45 67",
  luggageCount: "Количество багажа",
  childSeat: "Детское кресло",
  notNeeded: "Не требуется",
  pieces: "Штук",
  vehicleSelection: "Выбор автомобиля",
  selectVehicle: "Выберите автомобиль",
  roundTrip: "Трансфер туда и обратно",
  extraInfo: "Дополнительная информация",
  extraInfoPlaceholder: "Ваши особые пожелания или заметки...",
  maxCharacters: "Максимум 500 символов",
  makeReservation: "Забронировать",
  dailyRental: "Ежедневная аренда",
  dailyRentalDesc: "Комфортные городские и междугородние поездки с профессиональным водителем",
  
  // Voucher
  reservationConfirmed: "Ваше бронирование подтверждено!",
  voucherSent: "Информация о ваучере отправлена на ваш адрес электронной почты.",
  voucherNumber: "Номер ваучера",
  secretCode: "Секретный код",
  voucherNote: "Вы можете использовать номер ваучера и секретный код для отмены или изменения.",
  backToHome: "Вернуться на главную",
  downloadVoucher: "Скачать ваучер",
  
  // My Reservations
  myReservations: "Мои бронирования",
  checkReservation: "Проверить бронирование",
  enterVoucherInfo: "Введите номер ваучера и секретный код для отмены или изменения",
  enterVoucherNumber: "Введите номер ваучера",
  enterSecretCode: "Введите секретный код",
  searchReservation: "Поиск бронирования",
  reservationDetails: "Детали бронирования",
  reservationStatus: "Статус",
  serviceType: "Тип услуги",
  reservationDate: "Дата бронирования",
  totalPrice: "Общая стоимость",
  cancelReservation: "Отменить бронирование",
  modifyReservation: "Изменить бронирование",
  statusActive: "Активно",
  statusCancelled: "Отменено",
  statusCompleted: "Завершено",
  confirmCancel: "Вы уверены, что хотите отменить это бронирование?",
  cancelSuccess: "Бронирование успешно отменено",
  cancelError: "Произошла ошибка при отмене",
  notFound: "Бронирование не найдено",
  invalidCredentials: "Неверный номер ваучера или секретный код",
  
  // Quick Booking Form
  selectService: "Выберите услугу",
  searchContinue: "ПОИСК / ПРОДОЛЖИТЬ",
  
  // Why Us
  whyUs: "Почему мы?",
  personalizedExperience: "Персонализированный опыт путешествий",
  personalizedDesc: "Мы предлагаем индивидуальные планы путешествий для каждого клиента",
  wideDestinations: "Широкий выбор направлений",
  wideDestinationsDesc: "Транспортные и туристические услуги в самые красивые места Турции",
  comfortSafety: "Комфорт и безопасность",
  comfortSafetyDesc: "Безопасное путешествие на роскошных автомобилях с профессиональными водителями",
  support247: "Поддержка 24/7",
  support247Desc: "Мы всегда с вами, непрерывная поддержка клиентов",
  
  // Footer
  companyDesc: "Liberty Tour предоставляет услуги трансфера, туров и аренды автомобилей по всей Турции, базируясь в Анталии.",
  quickLinks: "Быстрые ссылки",
  ourServices: "Наши услуги",
  supportLine: "Линия поддержки",
  followUs: "Следите за нами",
  allRightsReserved: "Все права защищены",
  privacyPolicy: "Политика конфиденциальности",
  termsConditions: "Условия использования",
  
  // Common
  bookNow: "Забронировать сейчас",
  learnMore: "Подробнее",
  viewAll: "Посмотреть все",
  currency: "Валюта",
  price: "Цена",
  book: "Забронировать",
  email: "Электронная почта",
  emailPlaceholder: "example@email.com",
  
  // Services Page
  servicesPageTitle: "Наши услуги",
  servicesPageDesc: "Специальные услуги для вас в самых красивых местах Турции",
  
  // Private Tours Page
  privateToursTitle: "Частные туры",
  privateToursDesc: "Индивидуальные туристические программы и профессиональные экскурсии с гидом",
  popularTours: "Наши популярные туры",
  discoverTurkey: "Откройте для себя самые красивые места Турции",
  tourReservation: "Бронирование тура",
  tourSelection: "Выбор тура",
  selectTour: "Выберите тур",
  duration: "Продолжительность",
  highlights: "Основные моменты",
  included: "Включено",
  specialRequests: "Особые пожелания",
  moreInfo: "Подробнее",
  
  // Tour 1: Antalya City Tour
  tour1Name: "Обзорная экскурсия по Анталии",
  tour1Duration: "Полный день (8 часов)",
  tour1Price: "€35 с человека",
  tour1Highlight1: "Старый город Калеичи",
  tour1Highlight2: "Ворота Адриана",
  tour1Highlight3: "Водопады Дюден",
  tour1Highlight4: "Музей Анталии",
  tour1Include1: "Профессиональный гид",
  tour1Include2: "Обед",
  tour1Include3: "Входные билеты",
  tour1Include4: "Трансферы из отеля",
  tour1Description: "Исследуйте историческое сердце Анталии с её очаровательным старым городом, древними римскими воротами и потрясающими водопадами. Этот тур предлагает идеальное сочетание истории, культуры и природной красоты. Идеально подходит для любителей истории, фотографов и семей, желающих открыть для себя подлинное очарование средиземноморского побережья.",
  
  // Tour 2: Cappadocia
  tour2Name: "2-дневный тур в Каппадокию",
  tour2Duration: "2 дня / 1 ночь",
  tour2Price: "€120 с человека",
  tour2Highlight1: "Полёт на воздушном шаре",
  tour2Highlight2: "Подземные города",
  tour2Highlight3: "Музей под открытым небом Гёреме",
  tour2Highlight4: "Каменные грибы",
  tour2Include1: "Авиабилеты туда и обратно",
  tour2Include2: "Проживание в отеле",
  tour2Include3: "Все приёмы пищи",
  tour2Include4: "Профессиональный гид",
  tour2Include5: "Входные билеты",
  tour2Description: "Испытайте волшебный ландшафт Каппадокии с её уникальными скальными образованиями и подземными городами. Наблюдайте восход солнца с воздушного шара и исследуйте древние пещерные церкви. Идеально для искателей приключений, пар, ищущих романтику, и всех, кто хочет увидеть один из самых необычных пейзажей в мире.",
  
  // Tour 3: Pamukkale
  tour3Name: "Памуккале и Иераполис",
  tour3Duration: "Полный день (10 часов)",
  tour3Price: "€50 с человека",
  tour3Highlight1: "Белые травертиновые террасы",
  tour3Highlight2: "Древний Иераполис",
  tour3Highlight3: "Бассейн Клеопатры",
  tour3Include1: "Профессиональный гид",
  tour3Include2: "Обед",
  tour3Include3: "Входные билеты",
  tour3Include4: "Трансферы из отеля",
  tour3Description: "Откройте для себя потрясающие белые кальциевые террасы Памуккале и древний римский город Иераполис. Прогуляйтесь босиком по тёплым травертинам и искупайтесь в легендарном бассейне Клеопатры. Этот тур идеально подходит для любителей природы, энтузиастов велнеса и тех, кто интересуется древними цивилизациями и природными чудесами.",
  
  // Tour 4: Istanbul
  tour4Name: "Достопримечательности Стамбула",
  tour4Duration: "2 дня / 1 ночь",
  tour4Price: "€150 с человека",
  tour4Highlight1: "Голубая мечеть",
  tour4Highlight2: "Айя-София",
  tour4Highlight3: "Дворец Топкапы",
  tour4Highlight4: "Гранд Базар",
  tour4Include1: "Авиабилеты туда и обратно",
  tour4Include2: "Проживание в отеле",
  tour4Include3: "Профессиональный гид",
  tour4Include4: "Входные билеты",
  tour4Description: "Погрузитесь в богатую историю и яркую культуру Стамбула, где Восток встречается с Западом. Посетите знаковые достопримечательности, исследуйте оживлённые базары и ощутите уникальную атмосферу этого великолепного города. Идеально для любителей культуры, истории и путешественников, желающих испытать перекрёсток цивилизаций.",
  
  // Tour 5: Perge & Aspendos
  tour5Name: "Древние города Перге и Аспендос",
  tour5Duration: "Полный день (7 часов)",
  tour5Price: "€40 с человека",
  tour5Highlight1: "Древний город Перге",
  tour5Highlight2: "Театр Аспендоса",
  tour5Highlight3: "Римская архитектура",
  tour5Include1: "Профессиональный гид",
  tour5Include2: "Обед",
  tour5Include3: "Входные билеты",
  tour5Include4: "Трансферы из отеля",
  tour5Description: "Отправьтесь в прошлое, чтобы исследовать два наиболее хорошо сохранившихся древних города Турции. Восхититесь великолепным римским театром Аспендоса и прогуляйтесь по руинам Перге. Этот тур идеально подходит для любителей археологии, истории и семей, интересующихся древними цивилизациями и классической архитектурой.",
  
  // Tour 6: Ephesus
  tour6Name: "Древний город Эфес",
  tour6Duration: "Полный день (12 часов)",
  tour6Price: "€80 с человека",
  tour6Highlight1: "Библиотека Цельса",
  tour6Highlight2: "Большой театр",
  tour6Highlight3: "Храм Артемиды",
  tour6Include1: "Профессиональный гид",
  tour6Include2: "Обед",
  tour6Include3: "Входные билеты",
  tour6Include4: "Трансферы из отеля",
  tour6Description: "Посетите один из самых великолепных древних городов классического мира. Прогуляйтесь по мраморным улицам, где когда-то ходили древние римляне, и увидьте потрясающую библиотеку Цельса. Этот тур идеален для любителей истории, археологии и всех, кто очарован древнегреческой и римской цивилизациями.",
  
  // Tour 7: Antalya Aquarium
  tour7Name: "Аквариум Анталии",
  tour7Duration: "4 часа",
  tour7Price: "€40 с человека",
  tour7Highlight1: "Крупнейший в мире туннельный аквариум",
  tour7Highlight2: "Тропические виды рыб",
  tour7Highlight3: "Интерактивные экспозиции",
  tour7Highlight4: "Снежный мир",
  tour7Include1: "Входные билеты",
  tour7Include2: "Трансферы из отеля",
  tour7Include3: "Профессиональный гид",
  tour7Description: "Погрузитесь в подводный мир в одном из крупнейших аквариумных комплексов мира. Прогуляйтесь по впечатляющему туннельному аквариуму в окружении акул и скатов и исследуйте разнообразные морские экосистемы. Идеально для семей с детьми, любителей морской жизни и всех, кто ищет познавательный и развлекательный опыт.",
  
  // Tour 8: Tazı Canyon
  tour8Name: "Каньон Тазы",
  tour8Duration: "6 часов",
  tour8Price: "€45 с человека",
  tour8Highlight1: "Виды на каньон глубиной 400 м",
  tour8Highlight2: "Потрясающие панорамные виды",
  tour8Highlight3: "Природная фотография",
  tour8Highlight4: "Пешеходные тропы",
  tour8Include1: "Профессиональный гид",
  tour8Include2: "Обед",
  tour8Include3: "Трансферы из отеля",
  tour8Description: "Испытайте захватывающую дух красоту каньона Тазы, одного из самых впечатляющих природных чудес Турции. Встаньте на краю 400-метрового ущелья и насладитесь панорамными видами на горы Тавр. Этот тур идеально подходит для любителей природы, фотографов, искателей приключений и всех, кто ценит драматические пейзажи.",
  
  // Tour 9: St. Nicholas Memorial Museum
  tour9Name: "Мемориальный музей Святого Николая",
  tour9Duration: "5 часов",
  tour9Price: "€50 с человека",
  tour9Highlight1: "Оригинальная церковь Санта-Клауса",
  tour9Highlight2: "Византийская архитектура",
  tour9Highlight3: "Древний город Мира",
  tour9Highlight4: "Скальные гробницы",
  tour9Include1: "Профессиональный гид",
  tour9Include2: "Обед",
  tour9Include3: "Входные билеты",
  tour9Include4: "Трансферы из отеля",
  tour9Description: "Посетите место рождения легенды о Санта-Клаусе и исследуйте древнюю церковь Святого Николая в Демре. Откройте для себя византийские фрески и близлежащий древний город Мира с его впечатляющими скальными гробницами. Идеально для семей, любителей истории, культурных путешественников и тех, кто интересуется христианским наследием и древними цивилизациями.",
  
  // Tour 10: Köprülü Canyon
  tour10Name: "Парк приключений Кёпрюлю Каньон",
  tour10Duration: "8 часов",
  tour10Price: "€65 с человека",
  tour10Highlight1: "Рафтинг",
  tour10Highlight2: "Зиплайн",
  tour10Highlight3: "Походы по каньону",
  tour10Highlight4: "Активности в парке приключений",
  tour10Include1: "Всё оборудование",
  tour10Include2: "Профессиональные инструкторы",
  tour10Include3: "Обед",
  tour10Include4: "Страховка",
  tour10Include5: "Трансферы из отеля",
  tour10Description: "Получите заряд адреналина в насыщенный день в каньоне Кёпрюлю. Испытайте захватывающий рафтинг, пролетите по воздуху на зиплайне и насладитесь различными приключенческими активностями в потрясающих природных условиях. Идеально для искателей приключений, активных путешественников, групп друзей и семей с подростками, ищущих острых ощущений.",
  
  // Tour 11: Olympos - Çıralı
  tour11Name: "Олимпос – Чиралы",
  tour11Duration: "8 часов",
  tour11Price: "€55 с человека",
  tour11Highlight1: "Руины древнего Олимпоса",
  tour11Highlight2: "Нетронутый пляж Чиралы",
  tour11Highlight3: "Вечные огни Янарташ",
  tour11Highlight4: "Место гнездования морских черепах",
  tour11Include1: "Профессиональный гид",
  tour11Include2: "Обед",
  tour11Include3: "Входные билеты",
  tour11Include4: "Трансферы из отеля",
  tour11Description: "Исследуйте мистические руины древнего Олимпоса, расположенные в пышной долине, отдохните на нетронутом пляже Чиралы и станьте свидетелем вечных огней Янарташ. Этот уникальный тур сочетает историю, природу и мифологию. Идеально для любителей природы, пляжных энтузиастов, семей и тех, кто ищет спокойный отдых с культурной глубиной.",
  
  // Tour 12: Land of Legends
  tour12Name: "Земля легенд",
  tour12Duration: "8 часов",
  tour12Price: "€70 с человека",
  tour12Highlight1: "Впечатляющие водные горки",
  tour12Highlight2: "Аттракционы тематического парка",
  tour12Highlight3: "Торговая улица",
  tour12Highlight4: "Развлекательные шоу",
  tour12Include1: "Вход в парк",
  tour12Include2: "Трансферы из отеля",
  tour12Include3: "Профессиональный гид",
  tour12Description: "Испытайте максимальное развлечение с захватывающими водными горками, увлекательными аттракционами тематического парка и впечатляющими шоу. Исследуйте роскошную торговую улицу и насладитесь развлечениями мирового класса. Этот тур идеально подходит для семей с детьми, любителей острых ощущений, групп друзей и всех, кто ищет весёлый день, полный волнения и развлечений.",
  
  // Group Tours Page
  groupToursTitle: "Групповые туры",
  groupToursDesc: "Групповые туры и ежедневные экскурсии по экономичным ценам",
  groupTypesTitle: "Наши типы групп",
  groupTypesDesc: "Специальные решения для каждой группы",
  schoolGroups: "Школьные группы",
  schoolGroupsDesc: "Образовательные и веселые школьные поездки",
  corporateTrips: "Корпоративные поездки",
  corporateTripsDesc: "Корпоративные мероприятия и тимбилдинг",
  familyGroups: "Семейные группы",
  familyGroupsDesc: "Большие семейные встречи и особые случаи",
  capacity: "Вместимость",
  educationalGuide: "Образовательный гид",
  safeTransfer: "Безопасный трансфер",
  lunch: "Обед",
  insurance: "Страховка",
  professionalOrganization: "Профессиональная организация",
  luxuryVehicles: "Роскошные автомобили",
  catering: "Кейтеринг",
  activities: "Активности",
  flexibleProgram: "Гибкая программа",
  childFriendly: "Для детей",
  specialMenu: "Специальное меню",
  photoService: "Фотосервис",
  groupPackagesTitle: "Наши групповые пакеты",
  groupPackagesDesc: "Групповые скидки по специальным ценам",
  noPackagesYet: "Пакетов пока нет",
  packagesComingSoon: "Групповые пакеты будут добавлены в ближайшее время",
  hideInfo: "Скрыть информацию",
  getQuote: "Получить предложение",
  groupTourRequest: "Запрос группового тура",
  groupType: "Тип группы",
  selectGroupType: "Выберите тип группы",
  schoolGroup: "Школьная группа",
  corporateGroup: "Корпоративная группа",
  familyGroup: "Семейная группа",
  groupNameOrCompany: "Название группы / Название компании",
  groupNamePlaceholder: "Название группы или компании",
  participantCount: "Количество участников",
  authorizedPerson: "Контактное лицо",
  authorizedPersonPlaceholder: "Полное имя",
  phoneLabel: "Телефон",
  emailLabel: "Электронная почта",
  preferredDate: "Предпочтительная дата",
  tourDuration: "Продолжительность тура",
  selectDuration: "Выберите продолжительность",
  halfDay: "Полдня",
  fullDay: "Полный день",
  multiDay: "Многодневный",
  specialRequestsDetails: "Особые пожелания и детали",
  specialRequestsPlaceholder: "Детали о группе, особые пожелания, информация о бюджете...",
  maxChars: "Максимум 500 символов",
  processing: "Обработка...",
  sendQuoteRequest: "Отправить запрос предложения",
  
  // Car Rental Page
  carRentalTitle: "Аренда автомобилей",
  carRentalDesc: "Безопасная и комфортная аренда автомобилей в Анталии",
  carCategoriesTitle: "Наши категории автомобилей",
  carCategoriesDesc: "Выберите подходящий автомобиль",
  rentalAdvantagesTitle: "Преимущества аренды",
  rentalAdvantagesDesc: "Безопасный и комфортный опыт аренды",
  fullInsurance: "Полная страховка",
  fullInsuranceDesc: "Комплексные варианты страхования",
  flexibleDelivery: "Гибкая доставка",
  flexibleDeliveryDesc: "Аэропорт, отель или центр города",
  support247: "Поддержка 24/7",
  support247Desc: "Мы всегда с вами",
  affordablePrice: "Доступная цена",
  affordablePriceDesc: "Еженедельные и ежемесячные скидки",
  carRentalReservation: "Бронирование аренды автомобиля",
  carCategory: "Категория автомобиля",
  selectCarCategory: "Выберите категорию автомобиля",
  perDay: "день",
  pickupDate: "Дата получения",
  pickupTime: "Время получения",
  returnDate: "Дата возврата",
  returnTime: "Время возврата",
  pickupLocation: "Место получения",
  selectPickupLocation: "Выберите место получения",
  returnLocation: "Место возврата",
  selectReturnLocation: "Выберите место возврата",
  airport: "Аэропорт Анталии",
  cityCenter: "Центр города",
  hotelDelivery: "Доставка в отель",
  other: "Другое",
  fullName: "Полное имя",
  phone: "Телефон",
  email: "Электронная почта",
  fullInsuranceExtra: "Полная страховка (+15€/день)",
  gpsNavigation: "GPS навигация (+5€/день)",
  childSeat: "Детское кресло (+3€/день)",
  specialRequests: "Особые пожелания",
  specialRequestsPlaceholder: "Ваши особые пожелания или заметки...",
  maxCharacters: "Максимум 500 символов",
  makeReservation: "Забронировать",
  processing: "Обработка...",
  noCarsYet: "Пока нет автомобилей",
  carsSoonAdded: "Автомобили скоро будут добавлены",
  daily: "Ежедневно",
  
  // Villa Rental Page
  villaRentalTitle: "Аренда вилл",
  villaRentalDesc: "Роскошные виллы на берегу моря и дома для отдыха с частным бассейном",
  ourVillas: "Наши виллы",
  luxuryVillas: "Роскошные и комфортабельные виллы",
  villaReservation: "Бронирование виллы",
  checkIn: "Дата заезда",
  checkOut: "Дата выезда",
  guests: "Количество гостей",
  bedrooms: "Спальни",
  bathrooms: "Ванные комнаты",
  privatePool: "Частный бассейн",
  seaView: "Вид на море",
  garden: "Сад",
  parking: "Парковка",
  wifi: "WiFi",
  kitchen: "Кухня",
  villaCategories: "Категории вилл",
  selectSuitableVilla: "Выберите подходящую виллу",
  people: "Человек",
  night: "Ночь",
  details: "Подробнее",
  villaCategory: "Категория виллы",
  selectCategory: "Выберите категорию",
  checkInDate: "Дата заезда",
  checkOutDate: "Дата выезда",
  adultsCount: "Количество взрослых",
  childrenCount: "Количество детей",
  fullName: "Полное имя",
  fullNamePlaceholder: "Ваше имя и фамилия",
  phone: "Телефон",
  email: "Электронная почта",
  emailPlaceholder: "example@email.com",
  specialRequests: "Особые пожелания",
  specialRequestsPlaceholder: "Ваши особые пожелания или заметки...",
  maxCharacters: "Максимум 500 символов",
  processing: "Обработка...",
  makeReservation: "Забронировать",
  
  // Yacht Rental Page
  yachtRentalTitle: "Аренда яхт",
  yachtRentalDesc: "Незабываемые морские впечатления на роскошных яхтах и частных лодочных турах",
  ourYachts: "Наш яхтенный флот",
  luxuryYachts: "Роскошные яхты и лодки для морского удовольствия",
  yachtReservation: "Бронирование яхты",
  tourDate: "Дата тура",
  tourDuration: "Продолжительность тура",
  selectDuration: "Выберите продолжительность",
  halfDay: "Полдня (4 часа)",
  fullDay: "Полный день (8 часов)",
  sunset: "Закат (2 часа)",
  crew: "Экипаж",
  captain: "Капитан",
  meals: "Питание",
  drinks: "Напитки",
  fishingEquipment: "Рыболовное снаряжение",
  snorkelingGear: "Снаряжение для снорклинга",
  musicSystem: "Музыкальная система",
  yachtFleet: "Наш яхтенный флот",
  yachtFleetDesc: "Роскошные яхты и лодки для морского удовольствия",
  boatTours: "Лодочные туры",
  boatToursDesc: "Ежедневные лодочные туры и специальные организации",
  noYachtsYet: "Яхт пока нет",
  yachtsComingSoon: "Яхты будут добавлены в ближайшее время",
  noToursYet: "Туров пока нет",
  toursComingSoon: "Туры будут добавлены в ближайшее время",
  yachtType: "Тип яхты",
  selectYachtType: "Выберите тип яхты",
  motorYacht: "Моторная яхта",
  sailingYacht: "Парусная яхта",
  catamaran: "Катамаран",
  megaYacht: "Мега яхта",
  dailyTour: "Ежедневный тур",
  sunsetTour: "Тур на закате",
  startDate: "Дата начала",
  endDate: "Дата окончания",
  departurePort: "Порт отправления",
  selectPort: "Выберите порт",
  antalyaMarina: "Марина Анталия",
  kasPort: "Порт Каш",
  kalkanPort: "Порт Калкан",
  fethiyeMarina: "Марина Фетхие",
  bodrumMarina: "Марина Бодрум",
  passengerCount: "Количество пассажиров",
  fullNameLabel: "Полное имя",
  fullNamePlaceholder: "Полное имя",
  phoneLabel: "Телефон",
  phonePlaceholder: "+90 555 123 45 67",
  emailLabel: "Электронная почта",
  emailPlaceholder: "example@email.com",
  cateringService: "Кейтеринг",
  waterSportsEquipment: "Оборудование для водных видов спорта (Гидроцикл, Снорклинг)",
  professionalCrew: "Профессиональный экипаж",
  specialRequests: "Особые пожелания",
  specialRequestsPlaceholder: "Предпочтения по маршруту, особые пожелания...",
  maxCharacters: "Максимум 500 символов",
  processing: "Обработка...",
  makeReservation: "Забронировать",
  rent: "Арендовать",
  perDay: "/День",
  perHour: "/Час",
  perPerson: "/Человек",
  
  // About Page
  aboutSubtitle: "Надежные и качественные туристические услуги в Турции с 2019 года",
  ourStory: "Наша история",
  storyParagraph1: "Liberty Tour, основанная в Анталии в 2019 году, является одной из ведущих туристических компаний Турции. С момента нашего основания мы являемся пионерами в отрасли с нашим качественным и надежным подходом к обслуживанию, всегда ставя удовлетворенность клиентов на первое место.",
  storyParagraph2: "Имея более 6 лет опыта, мы обслужили более 285 000 довольных клиентов. С нашим современным автопарком из более чем 45 автомобилей мы предлагаем широкий спектр услуг от трансферов из аэропорта до частных туров, от аренды автомобилей до бронирования вилл.",
  storyParagraph3: "С нашей круглосуточной непрерывной поддержкой клиентов и профессиональной командой мы с вами в каждый момент вашего отпуска. Безопасность, комфорт и удовлетворенность клиентов - наши самые важные ценности.",
  yearsExperience: "Лет опыта",
  happyCustomers: "Довольных клиентов",
  vehicleFleet: "Автопарк",
  support: "Поддержка",
  ourMission: "Наша миссия",
  missionText: "Сделать отдых наших клиентов в Турции незабываемым, предоставляя туристические услуги высочайшего качества. Совершенствовать опыт путешествий с помощью безопасных, комфортных и персонализированных решений.",
  ourVision: "Наше видение",
  visionText: "Стать самой надежной и предпочитаемой туристической компанией Турции. Поддерживать нашу лидирующую позицию в отрасли с нашим инновационным подходом к обслуживанию и клиентоориентированным подходом.",
  ourValues: "Наши ценности",
  valuesSubtitle: "Основные ценности, которые делают нас теми, кто мы есть",
  valueSecurity: "Безопасность",
  valueSecurityDesc: "Безопасность наших клиентов превыше всего. Все наши автомобили регулярно обслуживаются и застрахованы.",
  valueCustomerFocus: "Ориентация на клиента",
  valueCustomerFocusDesc: "Удовлетворенность клиентов - наш приоритет. Мы создаем специальные решения для каждого из наших клиентов.",
  valueQuality: "Качество",
  valueQualityDesc: "Мы постоянно совершенствуемся, чтобы предоставлять услуги на самых высоких стандартах качества.",
  valueProfessionalism: "Профессионализм",
  valueProfessionalismDesc: "Мы всегда стремимся предоставить лучший сервис с нашей опытной и профессиональной командой.",
  valueInnovation: "Инновации",
  valueInnovationDesc: "Мы следим за инновациями в отрасли и постоянно улучшаем наши услуги.",
  valueHonesty: "Честность",
  valueHonestyDesc: "Мы завоевываем доверие наших клиентов нашим прозрачным и честным подходом к бизнесу.",
  
  // Blog Page
  blogSubtitle: "Советы путешественникам, путеводители по направлениям и туристические новости",
  blogPost1Title: "Топ-10 мест для посещения в Анталии",
  blogPost1Excerpt: "Самые красивые пляжи Анталии, древние города и природные красоты. Места, которые вы должны увидеть во время отпуска.",
  blogPost1Date: "15 января 2024",
  blogPost2Title: "На что обратить внимание при трансфере из аэропорта",
  blogPost2Excerpt: "Все детали и советы, которые вам нужно знать для безопасного и комфортного трансфера из аэропорта.",
  blogPost2Date: "10 января 2024",
  blogPost3Title: "Путеводитель по лодочным турам: Жемчужины Средиземноморья",
  blogPost3Excerpt: "Самые красивые лодочные туры, которые вы можете совершить на побережье Анталии, и бухты, которые стоит увидеть.",
  blogPost3Date: "5 января 2024",
  blogPost4Title: "Советы и хитрости по аренде автомобилей",
  blogPost4Excerpt: "На что нужно обратить внимание при аренде автомобиля в отпуске и способы найти лучшие цены.",
  blogPost4Date: "28 декабря 2023",
  blogPost5Title: "Самые красивые маршруты частных туров по Турции",
  blogPost5Excerpt: "Самые впечатляющие туристические маршруты Турции от Каппадокии до Памуккале, от Эфеса до Каша.",
  blogPost5Date: "20 декабря 2023",
  blogPost6Title: "Планирование отдыха на вилле: Что вам нужно знать",
  blogPost6Excerpt: "На что нужно обратить внимание до и после бронирования для идеального отдыха на вилле.",
  blogPost6Date: "15 декабря 2023",
  blogCategoryGuide: "Путеводитель",
  blogCategoryTransfer: "Трансфер",
  blogCategoryYacht: "Яхт-туры",
  blogCategoryCarRental: "Аренда автомобилей",
  blogCategoryPrivateTours: "Частные туры",
  blogCategoryVilla: "Вилла",
  minutes: "минут",
  readMore: "Читать далее",
  newsletterTitle: "Подпишитесь на нашу рассылку",
  newsletterSubtitle: "Будьте в курсе последних кампаний и советов путешественникам",
  subscribe: "Подписаться",
  
  // Contact Page
  title: "Контакты",
  subtitle: "Как мы можем вам помочь? Свяжитесь с нами",
  phone: "Телефон",
  responseTime: "Ответ в течение 24 часов",
  address: "Адрес",
  officeHours: "Понедельник - Воскресенье: 00:00 - 24:00",
  socialMedia: "Социальные сети",
  sendMessage: "Отправьте нам сообщение",
  messageSent: "Ваше сообщение успешно отправлено! Мы свяжемся с вами как можно скорее.",
  messageError: "Произошла ошибка при отправке сообщения. Пожалуйста, попробуйте еще раз.",
  fullName: "Полное имя",
  fullNamePlaceholder: "Ваше имя и фамилия",
  subject: "Тема",
  selectSubject: "Выберите тему",
  tourServices: "Туристические услуги",
  rentalServices: "Услуги аренды",
  other: "Другое",
  yourMessage: "Ваше сообщение",
  messagePlaceholder: "Напишите ваше сообщение здесь...",
  characters: "символов",
  sending: "Отправка...",
  visitUs: "Посетите нас",
  visitUsSubtitle: "Приходите в наш офис, мы будем рады помочь вам",
  formDescription: "Заполните форму для ваших вопросов, предложений или запросов на бронирование.",
  success: "Успешно!",
  successMessage: "Ваше сообщение успешно отправлено. Мы свяжемся с вами в ближайшее время.",
  error: "Ошибка!",
  errorMessage: "Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз или позвоните нам напрямую.",
  findUs: "Найдите нас",
  whyChooseUs: "Почему выбирают нас?",
  feature1Title: "Поддержка 24/7",
  feature1Desc: "Мы всегда с вами, вы можете связаться с нами в любое время.",
  feature2Title: "Профессиональная команда",
  feature2Desc: "Мы предоставляем лучший сервис с нашей командой с опытом более 6 лет.",
  feature3Title: "Надежный сервис",
  feature3Desc: "Проверенное качество с более чем 285 тысячами довольных клиентов.",
  name: "Полное имя",
  namePlaceholder: "Введите ваше полное имя",
  subjectPlaceholder: "Тема вашего сообщения",
  message: "Сообщение",
  send: "Отправить сообщение"
};

export default ruCommon;
